import { render, staticRenderFns } from "./Subfooter.vue?vue&type=template&id=405c6c04&scoped=true"
var script = {}
import style0 from "./Subfooter.vue?vue&type=style&index=0&id=405c6c04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405c6c04",
  null
  
)

export default component.exports